import { routeParentName } from 'ember-route-state/utils/route-parent-name';

export function routePaths(routeName) {
  const paths = [];
  do {
    paths.push(routeName);
  } while (routeName = routeParentName(routeName));
  return paths.reverse();
}
